module Meevo.Plugins.ClientMerge {
    class ClientMergeController {

        closeContext: Function;
        context: ClientMergeContext;
   
        static $inject = [
          "meevo.AppSettings",
          "meevo.components.common.DataService",
          "meevo.components.modal.ModalService",
          "meevo.components.tracking.TrackingService",
          "meevo.components.common.SecurityService",
          "meevo.components.common.IdentityService",
          "$rootScope",
          "$state"
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
          protected dataService: Meevo.Components.BaseClasses.IDataService,
          protected modalService: Meevo.Components.Modal.IModalService,
          protected trackingService: Meevo.Components.Tracking.ITrackingService,
          protected securityService: Meevo.Components.Common.ISecurityService,
          protected identityService: Meevo.Components.Common.IIdentityService,
          protected $rootScope: angular.IRootScopeService,
          protected $state: any) {
            
            let vm = this;
            vm.context = new ClientMergeContext(appSettings, dataService, modalService, trackingService, securityService, identityService, $rootScope);
            vm.closeContext = (): void => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
            }
        }
    }

    angular.module("meevo.plugins.clientMerge")
        .controller("meevo.plugins.clientMerge.ClientMergeController", ClientMergeController);
}